import { render } from "./PatientDetailsComponent.vue?vue&type=template&id=63095e8e&scoped=true"
import script from "./PatientDetailsComponent.vue?vue&type=script&lang=js"
export * from "./PatientDetailsComponent.vue?vue&type=script&lang=js"

import "./PatientDetailsComponent.vue?vue&type=style&index=0&id=63095e8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63095e8e"]])

export default __exports__